/**
 * 年齢フィルターオプション
 * @type {Array<{label: string, value: string|number}>}
 */
const AgeFilterOptions = [
  { label: "すべて", value: "all" },
  { label: "10歳", value: 10 },
  { label: "20歳", value: 20 },
  { label: "30歳", value: 30 },
  { label: "40歳", value: 40 },
  { label: "50歳", value: 50 },
  { label: "60歳", value: 60 },
  { label: "70歳", value: 70 },
  { label: "80歳以上", value: 80 },
];

/**
 * フィルター期間オプション
 * @type {Array<{label: string, value: number}>}
 */
const FilterTimeOptions = [
  { label: "すべて", value: 0 },
  { label: "1週間以内", value: 7 },
  { label: "2週間以内", value: 14 },
  { label: "1ヶ月以内", value: 30 },
  { label: "3ヶ月以内", value: 90 },
  { label: "6ヶ月以内", value: 180 },
  { label: "1年以内", value: 365 },
];

/**
 * 総来店回数用の範囲選択オプション（全期間用）- 最小値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMinOptionsAllTime = [
  { label: "下限なし", value: "no_min" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "15回", value: "15" },
  { label: "20回", value: "20" },
  { label: "25回", value: "25" },
  { label: "30回", value: "30" },
  { label: "40回", value: "40" },
  { label: "50回", value: "50" },
  { label: "60回", value: "60" },
  { label: "70回", value: "70" },
  { label: "80回", value: "80" },
  { label: "90回", value: "90" },
  { label: "100回", value: "100" },
  { label: "150回", value: "150" },
  { label: "200回", value: "200" },
  { label: "250回", value: "250" },
  { label: "300回", value: "300" },
  { label: "350回", value: "350" },
  { label: "400回", value: "400" },
  { label: "450回", value: "450" },
  { label: "500回", value: "500" },
  { label: "600回", value: "600" },
  { label: "700回", value: "700" },
  { label: "800回", value: "800" },
  { label: "900回", value: "900" },
  { label: "1000回", value: "1000" },
];

/**
 * 総来店回数用の範囲選択オプション（全期間用）- 最大値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMaxOptionsAllTime = [
  { label: "上限なし", value: "no_max" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "15回", value: "15" },
  { label: "20回", value: "20" },
  { label: "25回", value: "25" },
  { label: "30回", value: "30" },
  { label: "40回", value: "40" },
  { label: "50回", value: "50" },
  { label: "60回", value: "60" },
  { label: "70回", value: "70" },
  { label: "80回", value: "80" },
  { label: "90回", value: "90" },
  { label: "100回", value: "100" },
  { label: "150回", value: "150" },
  { label: "200回", value: "200" },
  { label: "250回", value: "250" },
  { label: "300回", value: "300" },
  { label: "350回", value: "350" },
  { label: "400回", value: "400" },
  { label: "450回", value: "450" },
  { label: "500回", value: "500" },
  { label: "600回", value: "600" },
  { label: "700回", value: "700" },
  { label: "800回", value: "800" },
  { label: "900回", value: "900" },
  { label: "1000回", value: "1000" },
];

/**
 * 総来店回数用の範囲選択オプション（当月内用）- 最小値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMinOptionsCurrentMonth = [
  { label: "下限なし", value: "no_min" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "11回", value: "11" },
  { label: "12回", value: "12" },
  { label: "13回", value: "13" },
  { label: "14回", value: "14" },
  { label: "15回", value: "15" },
  { label: "16回", value: "16" },
  { label: "17回", value: "17" },
  { label: "18回", value: "18" },
  { label: "19回", value: "19" },
  { label: "20回", value: "20" },
  { label: "21回", value: "21" },
  { label: "22回", value: "22" },
  { label: "23回", value: "23" },
  { label: "24回", value: "24" },
  { label: "25回", value: "25" },
  { label: "26回", value: "26" },
  { label: "27回", value: "27" },
  { label: "28回", value: "28" },
  { label: "29回", value: "29" },
  { label: "30回", value: "30" },
];

/**
 * 総来店回数用の範囲選択オプション（当月内用）- 最大値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMaxOptionsCurrentMonth = [
  { label: "上限なし", value: "no_max" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "11回", value: "11" },
  { label: "12回", value: "12" },
  { label: "13回", value: "13" },
  { label: "14回", value: "14" },
  { label: "15回", value: "15" },
  { label: "16回", value: "16" },
  { label: "17回", value: "17" },
  { label: "18回", value: "18" },
  { label: "19回", value: "19" },
  { label: "20回", value: "20" },
  { label: "21回", value: "21" },
  { label: "22回", value: "22" },
  { label: "23回", value: "23" },
  { label: "24回", value: "24" },
  { label: "25回", value: "25" },
  { label: "26回", value: "26" },
  { label: "27回", value: "27" },
  { label: "28回", value: "28" },
  { label: "29回", value: "29" },
  { label: "30回", value: "30" },
];

/**
 * 総来店回数用の範囲選択オプション（3ヶ月以内用）- 最小値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMinOptionsThreeMonths = [
  { label: "下限なし", value: "no_min" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "11回", value: "11" },
  { label: "12回", value: "12" },
  { label: "13回", value: "13" },
  { label: "14回", value: "14" },
  { label: "15回", value: "15" },
  { label: "16回", value: "16" },
  { label: "17回", value: "17" },
  { label: "18回", value: "18" },
  { label: "19回", value: "19" },
  { label: "20回", value: "20" },
  { label: "25回", value: "25" },
  { label: "30回", value: "30" },
  { label: "35回", value: "35" },
  { label: "40回", value: "40" },
  { label: "45回", value: "45" },
  { label: "50回", value: "50" },
  { label: "60回", value: "60" },
  { label: "70回", value: "70" },
  { label: "80回", value: "80" },
  { label: "90回", value: "90" },
];

/**
 * 総来店回数用の範囲選択オプション（3ヶ月以内用）- 最大値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMaxOptionsThreeMonths = [
  { label: "上限なし", value: "no_max" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "11回", value: "11" },
  { label: "12回", value: "12" },
  { label: "13回", value: "13" },
  { label: "14回", value: "14" },
  { label: "15回", value: "15" },
  { label: "16回", value: "16" },
  { label: "17回", value: "17" },
  { label: "18回", value: "18" },
  { label: "19回", value: "19" },
  { label: "20回", value: "20" },
  { label: "25回", value: "25" },
  { label: "30回", value: "30" },
  { label: "35回", value: "35" },
  { label: "40回", value: "40" },
  { label: "45回", value: "45" },
  { label: "50回", value: "50" },
  { label: "60回", value: "60" },
  { label: "70回", value: "70" },
  { label: "80回", value: "80" },
  { label: "90回", value: "90" },
];

/**
 * 総来店回数用の範囲選択オプション（半年以内用）- 最小値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMinOptionsHalfYear = [
  { label: "下限なし", value: "no_min" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "11回", value: "11" },
  { label: "12回", value: "12" },
  { label: "13回", value: "13" },
  { label: "14回", value: "14" },
  { label: "15回", value: "15" },
  { label: "16回", value: "16" },
  { label: "17回", value: "17" },
  { label: "18回", value: "18" },
  { label: "19回", value: "19" },
  { label: "20回", value: "20" },
  { label: "25回", value: "25" },
  { label: "30回", value: "30" },
  { label: "35回", value: "35" },
  { label: "40回", value: "40" },
  { label: "45回", value: "45" },
  { label: "50回", value: "50" },
  { label: "60回", value: "60" },
  { label: "70回", value: "70" },
  { label: "80回", value: "80" },
  { label: "90回", value: "90" },
  { label: "100回", value: "100" },
  { label: "120回", value: "120" },
  { label: "140回", value: "140" },
  { label: "160回", value: "160" },
  { label: "180回", value: "180" },
];

/**
 * 総来店回数用の範囲選択オプション（半年以内用）- 最大値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMaxOptionsHalfYear = [
  { label: "上限なし", value: "no_max" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "11回", value: "11" },
  { label: "12回", value: "12" },
  { label: "13回", value: "13" },
  { label: "14回", value: "14" },
  { label: "15回", value: "15" },
  { label: "16回", value: "16" },
  { label: "17回", value: "17" },
  { label: "18回", value: "18" },
  { label: "19回", value: "19" },
  { label: "20回", value: "20" },
  { label: "25回", value: "25" },
  { label: "30回", value: "30" },
  { label: "35回", value: "35" },
  { label: "40回", value: "40" },
  { label: "45回", value: "45" },
  { label: "50回", value: "50" },
  { label: "60回", value: "60" },
  { label: "70回", value: "70" },
  { label: "80回", value: "80" },
  { label: "90回", value: "90" },
  { label: "100回", value: "100" },
  { label: "120回", value: "120" },
  { label: "140回", value: "140" },
  { label: "160回", value: "160" },
  { label: "180回", value: "180" },
];

/**
 * 総来店回数用の範囲選択オプション（1年以内用）- 最小値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMinOptionsOneYear = [
  { label: "下限なし", value: "no_min" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "11回", value: "11" },
  { label: "12回", value: "12" },
  { label: "13回", value: "13" },
  { label: "14回", value: "14" },
  { label: "15回", value: "15" },
  { label: "16回", value: "16" },
  { label: "17回", value: "17" },
  { label: "18回", value: "18" },
  { label: "19回", value: "19" },
  { label: "20回", value: "20" },
  { label: "25回", value: "25" },
  { label: "30回", value: "30" },
  { label: "35回", value: "35" },
  { label: "40回", value: "40" },
  { label: "45回", value: "45" },
  { label: "50回", value: "50" },
  { label: "60回", value: "60" },
  { label: "70回", value: "70" },
  { label: "80回", value: "80" },
  { label: "90回", value: "90" },
  { label: "100回", value: "100" },
  { label: "125回", value: "125" },
  { label: "150回", value: "150" },
  { label: "175回", value: "175" },
  { label: "200回", value: "200" },
  { label: "225回", value: "225" },
  { label: "250回", value: "250" },
  { label: "275回", value: "275" },
  { label: "300回", value: "300" },
  { label: "325回", value: "325" },
  { label: "350回", value: "350" },
  { label: "365回", value: "365" },
];

/**
 * 総来店回数用の範囲選択オプション（1年以内用）- 最大値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMaxOptionsOneYear = [
  { label: "上限なし", value: "no_max" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "11回", value: "11" },
  { label: "12回", value: "12" },
  { label: "13回", value: "13" },
  { label: "14回", value: "14" },
  { label: "15回", value: "15" },
  { label: "16回", value: "16" },
  { label: "17回", value: "17" },
  { label: "18回", value: "18" },
  { label: "19回", value: "19" },
  { label: "20回", value: "20" },
  { label: "25回", value: "25" },
  { label: "30回", value: "30" },
  { label: "35回", value: "35" },
  { label: "40回", value: "40" },
  { label: "45回", value: "45" },
  { label: "50回", value: "50" },
  { label: "60回", value: "60" },
  { label: "70回", value: "70" },
  { label: "80回", value: "80" },
  { label: "90回", value: "90" },
  { label: "100回", value: "100" },
  { label: "125回", value: "125" },
  { label: "150回", value: "150" },
  { label: "175回", value: "175" },
  { label: "200回", value: "200" },
  { label: "225回", value: "225" },
  { label: "250回", value: "250" },
  { label: "275回", value: "275" },
  { label: "300回", value: "300" },
  { label: "325回", value: "325" },
  { label: "350回", value: "350" },
  { label: "365回", value: "365" },
];

/**
 * 総来店回数用の範囲選択オプション（任意期間用）- 最小値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMinOptionsCustomPeriod = [
  { label: "下限なし", value: "no_min" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "15回", value: "15" },
  { label: "20回", value: "20" },
  { label: "25回", value: "25" },
  { label: "30回", value: "30" },
  { label: "40回", value: "40" },
  { label: "50回", value: "50" },
  { label: "60回", value: "60" },
  { label: "70回", value: "70" },
  { label: "80回", value: "80" },
  { label: "90回", value: "90" },
  { label: "100回", value: "100" },
  { label: "150回", value: "150" },
  { label: "200回", value: "200" },
  { label: "250回", value: "250" },
  { label: "300回", value: "300" },
  { label: "350回", value: "350" },
  { label: "400回", value: "400" },
  { label: "450回", value: "450" },
  { label: "500回", value: "500" },
  { label: "600回", value: "600" },
  { label: "700回", value: "700" },
  { label: "800回", value: "800" },
  { label: "900回", value: "900" },
  { label: "1000回", value: "1000" },
];

/**
 * 総来店回数用の範囲選択オプション（任意期間用）- 最大値
 * @type {Array<{label: string, value: string}>}
 */
const TotalVisitMaxOptionsCustomPeriod = [
  { label: "上限なし", value: "no_max" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "15回", value: "15" },
  { label: "20回", value: "20" },
  { label: "25回", value: "25" },
  { label: "30回", value: "30" },
  { label: "40回", value: "40" },
  { label: "50回", value: "50" },
  { label: "60回", value: "60" },
  { label: "70回", value: "70" },
  { label: "80回", value: "80" },
  { label: "90回", value: "90" },
  { label: "100回", value: "100" },
  { label: "150回", value: "150" },
  { label: "200回", value: "200" },
  { label: "250回", value: "250" },
  { label: "300回", value: "300" },
  { label: "350回", value: "350" },
  { label: "400回", value: "400" },
  { label: "450回", value: "450" },
  { label: "500回", value: "500" },
  { label: "600回", value: "600" },
  { label: "700回", value: "700" },
  { label: "800回", value: "800" },
  { label: "900回", value: "900" },
  { label: "1000回", value: "1000" },
];

/**
 * 月平均来店回数用の範囲選択オプション - 最小値
 * @type {Array<{label: string, value: string}>}
 */
const MonthlyAverageMinOptions = [
  { label: "下限なし", value: "no_min" },
  { label: "1回未満", value: "less_1" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "11回", value: "11" },
  { label: "12回", value: "12" },
  { label: "13回", value: "13" },
  { label: "14回", value: "14" },
  { label: "15回", value: "15" },
  { label: "16回", value: "16" },
  { label: "17回", value: "17" },
  { label: "18回", value: "18" },
  { label: "19回", value: "19" },
  { label: "20回", value: "20" },
  { label: "21回", value: "21" },
  { label: "22回", value: "22" },
  { label: "23回", value: "23" },
  { label: "24回", value: "24" },
  { label: "25回", value: "25" },
  { label: "26回", value: "26" },
  { label: "27回", value: "27" },
  { label: "28回", value: "28" },
  { label: "29回", value: "29" },
  { label: "30回", value: "30" },
];

/**
 * 月平均来店回数用の範囲選択オプション - 最大値
 * @type {Array<{label: string, value: string}>}
 */
const MonthlyAverageMaxOptions = [
  { label: "上限なし", value: "no_max" },
  { label: "1回未満", value: "less_1" },
  { label: "1回", value: "1" },
  { label: "2回", value: "2" },
  { label: "3回", value: "3" },
  { label: "4回", value: "4" },
  { label: "5回", value: "5" },
  { label: "6回", value: "6" },
  { label: "7回", value: "7" },
  { label: "8回", value: "8" },
  { label: "9回", value: "9" },
  { label: "10回", value: "10" },
  { label: "11回", value: "11" },
  { label: "12回", value: "12" },
  { label: "13回", value: "13" },
  { label: "14回", value: "14" },
  { label: "15回", value: "15" },
  { label: "16回", value: "16" },
  { label: "17回", value: "17" },
  { label: "18回", value: "18" },
  { label: "19回", value: "19" },
  { label: "20回", value: "20" },
  { label: "21回", value: "21" },
  { label: "22回", value: "22" },
  { label: "23回", value: "23" },
  { label: "24回", value: "24" },
  { label: "25回", value: "25" },
  { label: "26回", value: "26" },
  { label: "27回", value: "27" },
  { label: "28回", value: "28" },
  { label: "29回", value: "29" },
  { label: "30回", value: "30" },
];

export {
  AgeFilterOptions,
  FilterTimeOptions,
  TotalVisitMinOptionsAllTime,
  TotalVisitMaxOptionsAllTime,
  TotalVisitMinOptionsCurrentMonth,
  TotalVisitMaxOptionsCurrentMonth,
  TotalVisitMinOptionsThreeMonths,
  TotalVisitMaxOptionsThreeMonths,
  TotalVisitMinOptionsHalfYear,
  TotalVisitMaxOptionsHalfYear,
  TotalVisitMinOptionsOneYear,
  TotalVisitMaxOptionsOneYear,
  TotalVisitMinOptionsCustomPeriod,
  TotalVisitMaxOptionsCustomPeriod,
  MonthlyAverageMinOptions,
  MonthlyAverageMaxOptions,
};
